<template>
  <div class="google-map">
    <input
      id="pac-input"
      class="controls"
      type="text"
      placeholder="Enter a location"
      v-show="inputBox == 1"
    />
    <div id="mapContainer">
      <p>{{ infoWindowText.name }}</p>
      <p>{{ infoWindowText.address }}</p>
    </div>
    <div :id="mapId" class="map-box"></div>
  </div>
</template>

<script>
const google = window.google
export default {
  name: 'google-map',
  props: {
    zoomControl: {
      default: false,
      type: Boolean
    },
    mapTypeControl: {
      default: true,
      type: Boolean
    },
    scaleControl: {
      default: false,
      type: Boolean
    },
    streetViewControl: {
      default: false,
      type: Boolean
    },
    rotateControl: {
      default: false,
      type: Boolean
    },
    fullscreenControl: {
      default: false,
      type: Boolean
    },
    inputBox: {
      default: 0,
      type: Number
    },
    draggable: {
      default: false,
      type: Boolean
    },
    mapId: {
      default: 'map',
      type: String
    },
    value: {
      default: () => ({
        address: {
          detail: '',
          placeName: '',
          placeId: ''
        },
        gps: {
          latitude: '',
          longitude: ''
        }
      }),
      type: Object
    }
  },
  data() {
    return {
      searchData: {},
      infoWindow: null,
      myLatLng: null,
      targetMap: null,
      geocoder: null,
      searchBox: null,
      autocomplete: null,
      infowindowElement: null,
      infoWindowText: {
        name: '',
        address: ''
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.targetMap = document.querySelector(`#${this.mapId}`)
      this.geocoder = new google.maps.Geocoder()
      this.infoWindow = new google.maps.InfoWindow()
      this.infowindowElement = document.querySelector('#mapContainer')
      // this.infowindowElement = this.$refs.mapContainer
      this.searchBox = document.querySelector('#pacInput')
      this.autocomplete = new google.maps.places.Autocomplete(this.searchBox)

      // value 값이 없을때는 실행되면 안된다.
      if (this.value) {
        switch (this.inputBox) {
          case 0:
            this.initGoogleMap()
            break
          case 1:
            this.searchBoxGoogleMap()
            break
          case 2:
            this.markerGoogleMap()
            break
          default:
            this.initGoogleMap()
            break
        }
      }
    })
  },
  methods: {
    initGoogleMap() {
      this.infoWindow.setContent(this.infowindowElement)
      // Options
      const myLatLng = new google.maps.LatLng(
        this.value.gps.latitude,
        this.value.gps.longitude
      )
      const mapOptions = {
        zoom: 16,
        center: myLatLng
        // draggable: false
      }

      let map = new google.maps.Map(this.targetMap, mapOptions)
      // Add marker
      let marker = new google.maps.Marker({
        map: map,
        anchorPoint: new google.maps.Point(0, -29),
        position: myLatLng
        // icon: require('@/assets/images'),
        // icon: {}
      })

      console.log(marker)

      // marker.setIcon(/** @type {google.maps.Icon} */({
      //     // url: responses[0].icon,
      //     size: new google.maps.Size(71, 71),
      //     origin: new google.maps.Point(0, 0),
      //     anchor: new google.maps.Point(17, 34),
      //     scaledSize: new google.maps.Size(35, 35)
      // }))

      // Bounce marker
      // marker.addListener('click', () => {
      //     this.infoWindow.open(this.target, marker)
      //     if (marker.getAnimation() !== null) {
      //         marker.setAnimation(null)
      //     } else {
      //         marker.setAnimation(google.maps.Animation.BOUNCE)
      //     }
      // })
    },
    searchBoxGoogleMap() {
      this.infowindowElement = document.querySelector('#mapContainer')
      if (this.infowindowElement) {
        this.infoWindow.setContent(this.infowindowElement)
        const myLatLng = new google.maps.LatLng(
          this.value.gps.latitude,
          this.value.gps.longitude
        )
        let map = new google.maps.Map(this.targetMap, {
          center: myLatLng,
          zoom: 16
        })
        let autocomplete = new google.maps.places.Autocomplete(this.searchBox)
        autocomplete.setTypes([])
        autocomplete.bindTo('bounds', map)

        map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.searchBox)

        let marker = new google.maps.Marker({
          map: map,
          anchorPoint: new google.maps.Point(0, -29),
          position: myLatLng
        })

        // marker.addListener('click', () => {
        //     this.infoWindow.open(map, marker);
        // });

        autocomplete.addListener('place_changed', () => {
          this.infoWindow.close()
          marker.setVisible(false)
          let place = autocomplete.getPlace()
          if (!place.geometry) {
            window.alert("No details available for input: '" + place.name + "'")
            return
          }
          if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport)
          } else {
            map.setCenter(place.geometry.location)
            map.setZoom(16)
          }
          // console.log(marker)
          // marker.setIcon(/** @type {google.maps.Icon} */({
          //     url: place.icon,
          //     size: new google.maps.Size(71, 71),
          //     origin: new google.maps.Point(0, 0),
          //     anchor: new google.maps.Point(17, 34),
          //     scaledSize: new google.maps.Size(35, 35)
          // }))

          // console.log(place.geometry.location.lat())
          // console.log(place.geometry.location.lng())
          marker.setPosition(place.geometry.location)
          marker.setVisible(true)

          let address = ''
          if (place.address_components) {
            address = [
              (place.address_components[0] &&
                place.address_components[0].short_name) ||
                '',
              (place.address_components[1] &&
                place.address_components[1].short_name) ||
                '',
              (place.address_components[2] &&
                place.address_components[2].short_name) ||
                ''
            ].join(' ')
          }

          this.infoWindow.setContent(
            '<div><strong>' + place.name + '</strong><br>' + address
          )
          this.infoWindow.open(map, marker)

          this.infoWindowText.name = place.name
          this.infoWindowText.address = place.formatted_address
          const self = this
          this.geocoder.geocode(
            { latLng: place.geometry.location },
            responses => {
              if (responses && responses.length > 0) {
                this.infoWindowText.name =
                  responses[0].address_components[2].short_name
                this.infoWindowText.address = responses[0].formatted_address

                self.$emit('input', {
                  address: {
                    detail: responses[0].formatted_address,
                    placeName: responses[0].address_components[2].short_name,
                    placeId: responses[0].place_id
                  },
                  gps: {
                    latitude: place.geometry.location.lat(),
                    longitude: place.geometry.location.lng()
                  }
                })
                //
                // console.log('search box address: ', {
                //     address: responses[0].formatted_address,
                //     placeName: responses[0].address_components[2].short_name,
                //     placeId: responses[0].place_id,
                //     latitude: place.geometry.location.lat(),
                //     longitude: place.geometry.location.lng()
                // })
              } else {
                self.$emit('input', {
                  address: '',
                  placeName: '',
                  placeId: '',
                  latitude: '',
                  longitude: ''
                })
              }
            }
          )

          // this.infoWindowText.address = address
          // this.infoWindow.setContent(this.infowindowElement)
          // this.infoWindow.open(map, marker)
        })
      } else {
        this.infowindowElement = document.querySelector('#mapContainer')
        console.log('info:', this.infowindowElement)
        this.searchBoxGoogleMap()
      }
    },
    markerGoogleMap() {
      this.infoWindow.setContent(this.infowindowElement)
      // Options
      const myLatLng = new google.maps.LatLng(
        this.value.gps.latitude,
        this.value.gps.longitude
      )
      const mapOptions = {
        zoom: 16,
        center: myLatLng
      }

      let map = new google.maps.Map(this.targetMap, mapOptions)

      let marker = new google.maps.Marker({
        map: map,
        draggable: true,
        animation: google.maps.Animation.DROP,
        position: {
          lat: this.value.gps.latitude,
          lng: this.value.gps.longitude
        },
        title: 'Drag me!'
      })

      // Bounce marker
      marker.addListener('click', () => {
        this.infoWindow.open(map, marker)
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null)
        } else {
          marker.setAnimation(google.maps.Animation.BOUNCE)
        }
      })

      let self = this
      // Drag marker
      marker.addListener('dragend', e => {
        this.value.gps.latitude = e.latLng.lat()
        this.value.gps.longitude = e.latLng.lng()
        let newLatLng = {
          lat: this.value.gps.latitude,
          lng: this.value.gps.longitude
        }
        marker.setPosition(newLatLng)
        this.geocoder.geocode({ latLng: newLatLng }, responses => {
          if (responses && responses.length > 0) {
            this.infoWindowText.name =
              responses[0].address_components[2].short_name
            this.infoWindowText.address = responses[0].formatted_address
            this.infoWindow.open(map, marker)

            self.$emit('location', {
              address: responses[0].formatted_address,
              placeName: responses[0].address_components[2].short_name,
              placeId: responses[0].place_id,
              latitude: this.value.gps.latitude,
              longitude: this.value.gps.longitude
            })
          } else {
            self.$emit('location', {
              address: '',
              placeName: '',
              placeId: '',
              latitude: '',
              longitude: ''
            })
          }
        })
      })
    }
  },
  watch: {
    value(value) {
      console.log('Google map init value:', value)
      console.log('input box number:', this.inputBox)
      if (typeof value.gps !== 'undefined') {
        switch (this.inputBox) {
          case 0:
            this.initGoogleMap()
            break
          case 1:
            this.searchBoxGoogleMap()
            break
          case 2:
            this.markerGoogleMap()
            break
          default:
            this.initGoogleMap()
            break
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.google-map {
  width: 100%;
  height: 100%;

  // #mapContainer {
  //   // display: none;
  // }

  .map-box {
    width: 100%;
    height: 100%;
    #mapContainer {
      display: inline;
    }
  }

  .controls {
    background-color: #fff;
    border-radius: 2px;
    border: 1px solid transparent;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    font-family: Roboto;
    font-size: 15px;
    font-weight: 300;
    height: 29px;
    margin-left: 17px;
    margin-top: 10px;
    outline: none;
    padding: 0 11px 0 13px;
    text-overflow: ellipsis;
    width: 400px;

    &:focus {
      border-color: #4d90fe;
    }
  }

  #pacInput {
    background-color: #fff;
    font-family: Roboto;
    font-size: 15px;
    font-weight: 300;
    margin-left: 12px;
    padding: 0 11px 0 13px;
    text-overflow: ellipsis;
    width: 300px;
  }

  #pacInput:focus {
    border-color: #4d90fe;
  }

  .pac-container {
    font-family: Roboto;
  }

  #type-selector {
    color: #fff;
    background-color: #4d90fe;
    padding: 5px 11px 0px 11px;
  }

  #type-selector label {
    font-family: Roboto;
    font-size: 13px;
    font-weight: 300;
  }
}
</style>
